import { render, staticRenderFns } from "./user-center.vue?vue&type=template&id=bd0a6a6a&scoped=true&"
import script from "./user-center.vue?vue&type=script&lang=js&"
export * from "./user-center.vue?vue&type=script&lang=js&"
import style0 from "./user-center.scss?vue&type=style&index=0&id=bd0a6a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0a6a6a",
  null
  
)

export default component.exports